import { jsx } from 'react/jsx-runtime';
import { useResourceDataContextSafe } from '../../context/resourceDataContext.js';
import { ResourceContentAudio } from './Audio/ResourceContentAudio.js';
import { ResourceContentDefault } from './Default/ResourceContentStoredFile.js';
import { ResourceContentDocument } from './Document/ResourceContentDocument.js';
import { ResourceContentImage } from './Image/ResourceContentImage.js';
import { ResourceContentNotepad } from './Notepad/ResourceContentNotepad.js';
import { ResourceContentPage } from './Page/ResourceContentPage.js';
import { ResourceContentText } from './Text/ResourceContentText.js';
import { ResourceContentVideo } from './Video/ResourceContentVideo.js';
import { isResourceDetailBookmark, isResourceDetailHighlight, isResourceDetailImage, isResourceDetailVideo, isResourceDetailAudio, isResourceDetailDocument, isResourceDetailDefault, isResourceDetailNotepad } from '../../../../resources/utils/resourceDetailGuards.js';
import { ResourceHeader } from '../ResourceHeader.js';

const ResourceContent = () => {
  const { resource } = useResourceDataContextSafe();
  if (isResourceDetailBookmark(resource)) {
    return /* @__PURE__ */ jsx(ResourceContentPage, {});
  }
  if (isResourceDetailHighlight(resource)) {
    return /* @__PURE__ */ jsx(ResourceContentText, {});
  }
  if (isResourceDetailImage(resource)) {
    return /* @__PURE__ */ jsx(ResourceContentImage, {});
  }
  if (isResourceDetailVideo(resource)) {
    return /* @__PURE__ */ jsx(ResourceContentVideo, {});
  }
  if (isResourceDetailAudio(resource)) {
    return /* @__PURE__ */ jsx(ResourceContentAudio, {});
  }
  if (isResourceDetailDocument(resource)) {
    return /* @__PURE__ */ jsx(ResourceContentDocument, {});
  }
  if (isResourceDetailDefault(resource)) {
    return /* @__PURE__ */ jsx(ResourceContentDefault, {});
  }
  if (isResourceDetailNotepad(resource)) {
    return /* @__PURE__ */ jsx(ResourceContentNotepad, {});
  }
  return /* @__PURE__ */ jsx(ResourceHeader, {});
};

export { ResourceContent };
//# sourceMappingURL=ResourceContent.js.map
